export class Metadata {
  constructor(
    pagination = {},
    sort = {},
    filters = {},
    columns = {},
    id = "id"
  ) {
    const { page = 1, pages = 0, perPage = 10, total = 0 } = pagination;
    const { field = "id", asc = true } = sort;
    const { search = "", created_at, updated_at } = filters;
    this.pagination = { page, pages, perPage, total };
    this.sort = { field, asc };
    this.filters = { search, created_at, updated_at, ...filters };

    this.columns = columns;
    this.id = id;
  }
}
